var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSlots = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 14,
  viewBox: "0 0 18 14",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.5 0H3.5C1.57031 0 0 1.57031 0 3.5V10.5C0 12.4297 1.57031 14 3.5 14H14.5C16.4297 14 18 12.4297 18 10.5V3.5C18 1.57031 16.4297 0 14.5 0ZM17 10.5C17 11.8784 15.8784 13 14.5 13H3.5C2.12158 13 1 11.8784 1 10.5V3.5C1 2.12158 2.12158 1 3.5 1H14.5C15.8784 1 17 2.12158 17 3.5V10.5ZM15.5 3H2.5C2.22363 3 2 3.22363 2 3.5V10.5C2 10.7764 2.22363 11 2.5 11H15.5C15.7764 11 16 10.7764 16 10.5V3.5C16 3.22363 15.7764 3 15.5 3ZM11.001 4V10H7.00049V4H11.001ZM3 4H6.00049V10H3V4ZM15 10H12.001V4H15V10Z",
  fill: "#E00C69"
})));
export { SvgSlots as ReactComponent };
export default __webpack_public_path__ + "assets/icons/slots.a25c5f.svg";